export const TARGET_TYPES = {
  MainTarget: 'Main Target',
  ProductTarget: 'Product Target',
  MonthlyTargetLayered: 'Monthly Target - Layered',
  ProductTargetLayered: 'Product Target - Layered',
  MonthlyTargetPrerequistite: 'Monthly Target - Prerequisite',
  ProductTargetPrerequisite: 'Product Target - Prerequisite',
  EarlyPaymentTarget: 'Early Payment Target',
  DropSizeTarget: 'Drop Size Target',
  RackChallenge: 'Rack Challenge',
  ProductGroupQuantity: 'Product Group Quantity',
  CdaSuperTarget: 'CDA Super Target'
};

export const TARGET_TYPES_OPTIONS = {
  'Main Target': TARGET_TYPES.MainTarget,
  'Product Target': TARGET_TYPES.ProductTarget,
  'Monthly Layered Target': TARGET_TYPES.MonthlyTargetLayered,
  'Product Layered Target': TARGET_TYPES.ProductTargetLayered,
  'Monthly Prerequisite Target': TARGET_TYPES.MonthlyTargetPrerequistite,
  'Product Prerequisite Target': TARGET_TYPES.ProductTargetPrerequisite,
  'Early Payments Points': TARGET_TYPES.EarlyPaymentTarget,
  'Drop Size Booster Points': TARGET_TYPES.DropSizeTarget,
  'Rack Challenge': TARGET_TYPES.RackChallenge,
  'Product Group Quantity': TARGET_TYPES.ProductGroupQuantity,
  'CDA Super Target': TARGET_TYPES.CdaSuperTarget
};

export const ensureCdaSuperTargetOption = (options = []) => {
  const list = Array.isArray(options) ? options : [];
  const alreadyPresent = list.some(
    (option) =>
      option?.displayText === TARGET_TYPES.CdaSuperTarget ||
      option?.value === TARGET_TYPES.CdaSuperTarget
  );
  if (alreadyPresent) return list;
  return [
    ...list,
    {
      id: TARGET_TYPES.CdaSuperTarget,
      displayText: TARGET_TYPES.CdaSuperTarget,
      isBadge: false,
      value: TARGET_TYPES.CdaSuperTarget
    }
  ];
};

export const EARLY_PAYMENT_TYPES = [
  'EARLY_PAYMENT_SALES_TARGET',
  'Early Payments Points'
];
export const DROP_SIZE_TYPES = ['BOOSTER_TARGET', 'Drop Size Booster Points'];

export const IMAGETYPE = {
  Foreground: 'foreground-image',
  Background: 'background-image'
};

export const BOOLEAN_VALUES = {
  TRUE: true,
  FALSE: false
};

export const DISPLAY_CONTENT_VARIANT = {
  EARLY_PAYMENT: 'earlyPayment',
  MAIN: 'main',
  LAYERED: 'layered'
};

export const PRODUCT_GROUP_QUANTITY_WARNING = {
  title:
    'Lottery Targets are created through an automated process and cannot be created manually.',
  description:
    'Once generated, the target will be available in Draft status, where you can review, update, and publish it as required.'
};
